import React from 'react';
import Dialog from '@components/atoms/dialog/dialog';
import { useTranslation } from 'next-i18next';
import sanitizer from '@helpers/sanitizer';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import styles from './validation-modal.module.scss';

type ValidationModalProps = {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  type: 'success' | 'error';
};

const ValidationModal: React.FC<ValidationModalProps> = (props) => {
  const { isOpen, onClose, type } = props;

  const router = useRouter();
  const { t } = useTranslation('professional-sellers');

  const handleCloseDialog = (shouldGoHome: boolean) => {
    onClose(false);
    if (shouldGoHome) {
      router.push('/');
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      closeDialog={() => handleCloseDialog(false)}
      key={`openValidationModal${isOpen}`}
      hasCloseIcon
      styles={{
        content: {
          maxWidth: '600px',
        },
      }}
    >
      <div className={clsx(styles.modalValidationForm, 'vc-modal__innerContainer')}>
        <div className={clsx(styles.modalValidationForm__content)}></div>
        {type === 'success' && (
          <>
            <p
              className={clsx(styles.modalValidationForm__text)}
              dangerouslySetInnerHTML={{ __html: sanitizer(t('PRO_SELLERS.FORM.VALIDATION.MESSAGE')) }}
            ></p>
            <button
              type="button"
              onClick={() => handleCloseDialog(true)}
              className={clsx('vc-btn', 'vc-btn--primary', 'vc-btn--large', styles.modalValidationForm__btn)}
            >
              OK
            </button>
          </>
        )}
        {type === 'error' && (
          <>
            <p
              className={clsx(styles.modalValidationForm__text, styles['modalValidationForm__text--error'])}
              dangerouslySetInnerHTML={{ __html: sanitizer(t('PRO_SELLERS.FORM.VALIDATION.ERROR')) }}
            ></p>
            <button
              className={clsx('vc-btn', 'vc-btn--primary', 'vc-btn--large', styles.modalValidationForm__btn)}
              type="button"
              onClick={() => handleCloseDialog(false)}
            >
              {t('PRO_SELLERS.FORM.VALIDATION.RETRY')}
            </button>
          </>
        )}
      </div>
    </Dialog>
  );
};

export default ValidationModal;
